import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcdd9c2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "searchMain bg-fff m-t-8" }
const _hoisted_3 = { class: "d-f" }
const _hoisted_4 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Payout Round", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_family icon-old-QuickSetup",
  style: {"font-size":"unset"}
}, null, -1))
const _hoisted_7 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Entity", -1))
const _hoisted_9 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "BU", -1))
const _hoisted_11 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Code", -1))
const _hoisted_13 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Program Name", -1))
const _hoisted_15 = { class: "d-f m-t-16" }
const _hoisted_16 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Payout Round Status", -1))
const _hoisted_18 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Total Amount w/o VAT", -1))
const _hoisted_20 = { class: "d-f flex-d-c flex-w-auto m-l-16" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Total Amount w VAT", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f flex-w-auto flex-d-c m-l-16" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto m-l-16 hide" }, null, -1))
const _hoisted_24 = { class: "d-f m-t-16 search-btns" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_27 = { class: "main bg-fff m-t-8 flex-w-auto d-f flex-d-c" }
const _hoisted_28 = { class: "d-f justify-e" }
const _hoisted_29 = { class: "d-f" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Add all claims ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_32 = { class: "table-wrapper flex-w-auto m-t-16" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font_family icon-shanchu",
  style: {"font-size":"24px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_entity_selector = _resolveComponent("entity-selector")!
  const _component_bu_selector = _resolveComponent("bu-selector")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_TableWrapper = _resolveComponent("TableWrapper")!
  const _component_payout_round = _resolveComponent("payout-round")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createBlock(_component_main_wrapper, { className: "p-l-r-10" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.roundClick && _ctx.roundClick(...args)))
              }, [
                _createVNode(_component_a_input, {
                  value: _ctx.showParams.payoutRound,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showParams.payoutRound) = $event)),
                  disabled: "",
                  class: "round-input",
                  placeholder: "Please input"
                }, {
                  suffix: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_entity_selector, {
                value: _ctx.searchParams.entity,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.entity) = $event)),
                allowClear: true,
                mode: "multiple"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_bu_selector, {
                value: _ctx.searchParams.bu,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.bu) = $event)),
                allowClear: true,
                mode: "multiple",
                isCurrent: true
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.programCode,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParams.programCode) = $event)),
                placeholder: "Please input"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_a_input, {
                value: _ctx.searchParams.programName,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParams.programName) = $event)),
                placeholder: "Please input"
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_a_input, {
                value: _ctx.showParams.payoutRoundStatus,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showParams.payoutRoundStatus) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_a_input, {
                value: _ctx.showParams.woTotal,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showParams.woTotal) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_a_input, {
                value: _ctx.showParams.wTotal,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showParams.wTotal) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _hoisted_22,
            _hoisted_23
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.$btnPermissions('PP02', '/spotCheckingControlling'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "m-l-16",
                  onClick: _withModifiers(_ctx.doReset, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.$btnPermissions('PP01', '/spotCheckingControlling'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  class: "m-l-16",
                  type: "primary",
                  onClick: _withModifiers(_ctx.doSearch, ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              (_ctx.$btnPermissions('PP03', '/spotCheckingControlling'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "m-l-16",
                    style: {"line-height":"16px","height":"35px"},
                    disabled: _ctx.showParams.payoutRoundStatus !== 'Active',
                    loading: _ctx.addAllClamsLoading,
                    onClick: _ctx.addAllClaims
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('PP04', '/spotCheckingControlling'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    class: "m-l-16",
                    style: {"line-height":"16px","height":"35px"},
                    disabled: 
                !_ctx.tableData ||
                _ctx.tableData.length === 0 ||
                _ctx.showParams.payoutRoundStatus !== 'Active'
              ,
                    onClick: _ctx.submitClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_TableWrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  class: "tab-container default-self-table-text",
                  columns: _ctx.columnsData,
                  scroll: { x: '', y: _ctx.tableHeight },
                  pagination: false,
                  dataSource: _ctx.tableData,
                  rowKey: "programId",
                  rowClassName: 
                (record, index) => (index % 2 === 1 ? 'table-striped' : null)
              
                }, {
                  programName: _withCtx(({ record }) => [
                    _createVNode(_component_a_tooltip, null, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.programName), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.programNameClick(record)),
                          class: "toolip"
                        }, _toDisplayString(record.programName), 9, _hoisted_33)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  operation: _withCtx(({ record }) => [
                    _createVNode(_component_a_tooltip, null, {
                      title: _withCtx(() => [
                        _hoisted_34
                      ]),
                      default: _withCtx(() => [
                        (_ctx.$btnPermissions('PP05', '/spotCheckingControlling'))
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              type: "link",
                              style: {"padding":"0"},
                              disabled: _ctx.showParams.payoutRoundStatus !== 'Active',
                              onClick: ($event: any) => (_ctx.deleteClick(record))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_35
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["columns", "scroll", "dataSource", "rowClassName"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (_ctx.roundVisible)
        ? (_openBlock(), _createBlock(_component_payout_round, {
            key: 0,
            isUploadVisible: _ctx.roundVisible,
            payoutRound: _ctx.showParams.payoutRound,
            onCloseUploadVisible: _ctx.closeRound,
            onConfirmRound: _ctx.confirmRound
          }, null, 8, ["isUploadVisible", "payoutRound", "onCloseUploadVisible", "onConfirmRound"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}